import React, { useEffect, useState } from 'react';
import { X, Search } from 'lucide-react';

const SearchModal = ({ open, onClose, action = 'https://jilongot.com/search.html' }) => {
  const [q, setQ] = useState('');
  useEffect(() => {
    const onEsc = (e) => e.key === 'Escape' && onClose?.();
    if (open) document.addEventListener('keydown', onEsc);
    return () => document.removeEventListener('keydown', onEsc);
  }, [open, onClose]);

  if (!open) return null;
  const submit = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    const url = `${action}?keyword=${encodeURIComponent(q.trim())}`;
    window.open(url, '_blank', 'noreferrer');
    onClose?.();
  };

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-start justify-center pt-24 px-4"
      onClick={onClose}
      data-testid="search-modal"
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors"
        aria-label="Close"
        data-testid="search-modal-close"
      >
        <X size={20} />
      </button>
      <form
        onSubmit={submit}
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-2xl bg-white rounded-xl shadow-2xl p-6"
      >
        <div className="flex items-center gap-3 border-b-2 border-[#0a3d8f] pb-3">
          <Search size={22} className="text-[#0a3d8f]" />
          <input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Cari produk, berita, atau kata kunci..."
            className="flex-1 text-lg font-medium outline-none"
            data-testid="search-modal-input"
          />
          <button
            type="submit"
            className="bg-[#0a3d8f] text-white text-sm font-semibold px-4 py-2 rounded-md hover:bg-[#082e6b]"
            data-testid="search-modal-submit"
          >
            Cari
          </button>
        </div>
        <p className="text-xs text-gray-500 mt-3">
          Tekan Enter untuk mencari di jilongot.com · <span className="font-mono">ESC</span> untuk keluar
        </p>
      </form>
    </div>
  );
};

export default SearchModal;
